import { useMutation } from "react-query";
import { enqueueSnackbar } from "notistack";
import { checkPassport } from "src/shared/data-access/wsConsumers/gateway";
import { AxiosError } from "axios";
import { Dispatch, SetStateAction } from "react";

export const useCheckPassport = (
  setOpen: Dispatch<SetStateAction<boolean>>,
  setHasCheckedIdentitySuccessfully?: Dispatch<SetStateAction<boolean>>,
) => {
  return useMutation({
    mutationFn: checkPassport,
    mutationKey: "checkPassport",
    onSuccess: (data) => {
      if (setHasCheckedIdentitySuccessfully) {
        setHasCheckedIdentitySuccessfully(true);
      }
      setOpen(false);
      enqueueSnackbar(data?.data, {
        variant: "success",
      });
    },
    onError: (error: AxiosError<string>) => {
      if (setHasCheckedIdentitySuccessfully) {
        setHasCheckedIdentitySuccessfully(false);
      }
      enqueueSnackbar(error?.response?.data, {
        variant: "warning",
      });
    },
  });
};
